export enum UnitApplicationParentType {
    None = 0,
    Organization = 1,
    Holding = 2,
    LP = 4
}